export class FileTooLargeNotification extends Error {
    DisplayMessage: string;
    /**
     *
     */
    constructor(message:string, displayMessage: string) {
        super(message);
        
        this.DisplayMessage = displayMessage;
    }
}